/** Token: { c: class suffix, t: text } — c maps to .ca-ide-tok--{c} */

export const IDE_SNIPPETS = {
  build: {
    title: 'ArcRollout.ts',
    tabs: ['ArcRollout.ts', 'flags.schema.ts', 'tenant.ts'],
    activeTab: 0,
    lineStart: 18,
    intervalMs: 42,
    lines: [
      [{ c: 'comment', t: '// Progressive rollout — tenant-aware feature flags' }],
      [{ c: 'plain', t: ' ' }],
      [
        { c: 'kw', t: 'export' },
        { c: 'plain', t: ' ' },
        { c: 'kw', t: 'async' },
        { c: 'plain', t: ' ' },
        { c: 'kw', t: 'function' },
        { c: 'plain', t: ' ' },
        { c: 'fn', t: 'enableArcRollout' },
        { c: 'punct', t: '(' },
        { c: 'param', t: 'ctx' },
        { c: 'punct', t: ': ' },
        { c: 'type', t: 'TenantContext' },
        { c: 'punct', t: ')' },
        { c: 'plain', t: ' ' },
        { c: 'punct', t: '{' },
      ],
      [
        { c: 'plain', t: '  ' },
        { c: 'kw', t: 'const' },
        { c: 'plain', t: ' ' },
        { c: 'var', t: 'cohort' },
        { c: 'plain', t: ' ' },
        { c: 'punct', t: '=' },
        { c: 'plain', t: ' ' },
        { c: 'kw', t: 'await' },
        { c: 'plain', t: ' ' },
        { c: 'var', t: 'ctx' },
        { c: 'punct', t: '.' },
        { c: 'fn', t: 'analytics' },
        { c: 'punct', t: '.' },
        { c: 'fn', t: 'slice' },
        { c: 'punct', t: '({ ' },
        { c: 'prop', t: 'env' },
        { c: 'punct', t: ': ' },
        { c: 'str', t: "'prod'" },
        { c: 'punct', t: ' })' },
      ],
      [
        { c: 'plain', t: '  ' },
        { c: 'kw', t: 'return' },
        { c: 'plain', t: ' ' },
        { c: 'var', t: 'cohort' },
        { c: 'punct', t: '.' },
        { c: 'prop', t: 'percentage' },
        { c: 'plain', t: ' ' },
        { c: 'punct', t: '>=' },
        { c: 'plain', t: ' ' },
        { c: 'num', t: '0.25' },
        { c: 'plain', t: ' ' },
        { c: 'punct', t: '&&' },
        { c: 'plain', t: ' ' },
        { c: 'var', t: 'ctx' },
        { c: 'punct', t: '.' },
        { c: 'prop', t: 'flags' },
        { c: 'punct', t: '.' },
        { c: 'prop', t: 'arc' },
        { c: 'plain', t: ' ' },
        { c: 'punct', t: '===' },
        { c: 'plain', t: ' ' },
        { c: 'kw', t: 'true' },
      ],
      [{ c: 'plain', t: '}' }],
    ],
  },

  design: {
    title: 'tokens.css',
    tabs: ['tokens.css', 'theme.dark.css'],
    activeTab: 0,
    lineStart: 1,
    intervalMs: 38,
    lines: [
      [{ c: 'comment', t: '/* CrimsonArc Technologies — design system surface tokens */' }],
      [{ c: 'plain', t: ' ' }],
      [
        { c: 'sel', t: ':root' },
        { c: 'plain', t: ' ' },
        { c: 'punct', t: '{' },
      ],
      [
        { c: 'plain', t: '  ' },
        { c: 'prop', t: '--ca-crimson-500' },
        { c: 'punct', t: ': ' },
        { c: 'str', t: '#dc2626' },
        { c: 'punct', t: ';' },
      ],
      [
        { c: 'plain', t: '  ' },
        { c: 'prop', t: '--ca-radius-lg' },
        { c: 'punct', t: ': ' },
        { c: 'num', t: '1.25rem' },
        { c: 'punct', t: ';' },
      ],
      [
        { c: 'plain', t: '  ' },
        { c: 'prop', t: '--ca-font-display' },
        { c: 'punct', t: ': ' },
        { c: 'str', t: "'Outfit', system-ui, sans-serif" },
        { c: 'punct', t: ';' },
      ],
      [
        { c: 'plain', t: '  ' },
        { c: 'prop', t: '--ca-shadow-elevated' },
        { c: 'punct', t: ': ' },
        { c: 'num', t: '0 24px 80px' },
        { c: 'plain', t: ' ' },
        { c: 'fn', t: 'rgba' },
        { c: 'punct', t: '(' },
        { c: 'num', t: '0,0,0,.45' },
        { c: 'punct', t: ')' },
        { c: 'punct', t: ';' },
      ],
      [{ c: 'punct', t: '}' }],
    ],
  },

  deploy: {
    mode: 'terminal',
    title: 'Terminal',
    intervalMs: 55,
    lines: [
      [{ c: 'term_prompt', t: '$ ' }, { c: 'term_cmd', t: 'git push origin main' }],
      [{ c: 'term_dim', t: 'Enumerating objects: 42, done.' }],
      [{ c: 'term_dim', t: 'Compressing objects: 100% (28/28), done.' }],
      [{ c: 'term_green', t: 'To github.com:crimsonarc/platform.git' }],
      [{ c: 'term_green', t: '   a1b2c3d..e8f9a0b  main -> main' }],
      [{ c: 'term_dim', t: '✓ CI pipeline triggered • deploy preview ready' }],
    ],
  },

  observe: {
    title: 'observer.ts',
    tabs: ['observer.ts', 'pipeline.log'],
    activeTab: 0,
    lineStart: 108,
    intervalMs: 35,
    highlightLineIndex: 3,
    lines: [
      [
        { c: 'log_tag', t: '[CRIMSON]' },
        { c: 'plain', t: ' ' },
        { c: 'log_file', t: 'api.ts:204' },
        { c: 'plain', t: '  ' },
        { c: 'log_info', t: 'INFO' },
        { c: 'plain', t: '  ' },
        { c: 'log_msg', t: 'request completed in 42ms' },
      ],
      [
        { c: 'log_tag', t: '[CRIMSON]' },
        { c: 'plain', t: ' ' },
        { c: 'log_file', t: 'cache.ts:88' },
        { c: 'plain', t: '  ' },
        { c: 'log_warn', t: 'WARN' },
        { c: 'plain', t: '  ' },
        { c: 'log_msg', t: 'invalidating edge cache (eu-west)' },
      ],
      [
        { c: 'log_tag', t: '[CRIMSON]' },
        { c: 'plain', t: ' ' },
        { c: 'log_file', t: 'pipeline.ts:44' },
        { c: 'plain', t: '  ' },
        { c: 'log_warn', t: 'WARN' },
        { c: 'plain', t: '  ' },
        { c: 'log_msg', t: 'retrying upstream (attempt 2/3)' },
      ],
      [
        { c: 'plain', t: '  ' },
        { c: 'punct', t: '→' },
        { c: 'plain', t: ' ' },
        { c: 'kw', t: 'await' },
        { c: 'plain', t: ' ' },
        { c: 'fn', t: 'backoff' },
        { c: 'punct', t: '(' },
        { c: 'num', t: '320' },
        { c: 'punct', t: ')' },
        { c: 'plain', t: ' ' },
        { c: 'comment', t: '// jittered delay' },
      ],
    ],
  },
};
